import type { ReactNode } from 'react';
import { css, cx } from '@linaria/atomic';
import type { CommonHTMLLIAttributes } from '@frontend/types';
import { CheckIcon } from '../../icon';
import * as styles from './listbox-li.styles';
import type { ListboxOptionGetterProps } from './use-listbox';

const spanStyle = css`
  cursor: default;
`;

type ListboxLiProps = CommonHTMLLIAttributes &
  ListboxOptionGetterProps & {
    children: ReactNode;
    trackingId?: string;
  };

export const ListboxLi = ({ children, trackingId, className, ...rest }: ListboxLiProps) => {
  const isDisabled = rest['aria-disabled'];
  const isSelected = rest['aria-selected'];

  const liClassName = cx(styles.liBaseStyle, isDisabled ? styles.liDisabledStyle : styles.liInteractiveStyle);

  const iconClassName = cx(styles.iconBaseStyle, isSelected ? styles.iconSelectedStyle : styles.iconNotSelectedStyle);

  return (
    <li className={cx(liClassName, className)} {...rest} data-trackingid={trackingId}>
      <span className={spanStyle}>{children}</span>
      <CheckIcon color='primary' className={iconClassName} />
    </li>
  );
};
